/*
    Imports the Roast API URL from the config.
*/

import apiCtrl from '@/services/api/abstract/abstract-api.js';
export default {
  getUser: function(userId, options = {}) {
    return apiCtrl.get('/user/' + userId, options);
  },
  getUsers: function(options) {
    return apiCtrl.get('/user', options);
  },
};
